var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ds-control dsf_teas_class_album_details mobile",
      class: { "ds-no-padding": !_vm.isDesign },
    },
    [
      _c("div", { staticClass: "album_nav" }, [
        _c("div", { staticClass: "nav_left" }, [
          _vm.isShowCheck
            ? _c(
                "div",
                {
                  staticClass: "nav_left_qx",
                  on: {
                    click: function ($event) {
                      _vm.isShowCheck = false
                    },
                  },
                },
                [_vm._v("取消")]
              )
            : _c(
                "div",
                { staticClass: "icon_back", on: { click: _vm.goBack } },
                [
                  _c("i", { staticClass: "iconfont icon-icon-back" }),
                  _vm._v(" 返回 "),
                ]
              ),
        ]),
        _c("div", { staticClass: "nav_content" }, [
          _vm._v(
            _vm._s(
              _vm.chooseArr.length && _vm.isShowCheck
                ? "已选择（" + _vm.chooseArr.length + "张)"
                : "相册详情"
            )
          ),
        ]),
        _vm.isShowCheck
          ? _c(
              "div",
              { staticClass: "nav_btn", on: { click: _vm.selectAll } },
              [_vm._v("全选")]
            )
          : _c(
              "div",
              { staticClass: "nav_btn", on: { click: _vm.chooseAlbumList } },
              [_vm._v("选择")]
            ),
      ]),
      _c("van-image", {
        staticClass: "album_cover_img",
        attrs: {
          width: "100%",
          height: "110px",
          fit: "cover",
          src: _vm._f("imgFormat")(_vm.queryString.coverPhoto),
        },
        scopedSlots: _vm._u([
          {
            key: "error",
            fn: function () {
              return [
                _c("img", {
                  staticClass: "err_img",
                  attrs: {
                    src: require("../../assets/styles/themes/img/photoAlbum2.png"),
                    alt: "",
                  },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("div", { staticClass: "album_title" }, [
        _c("div", { staticClass: "album_title_box" }, [
          _c("div", { staticClass: "albumName" }, [_vm._v("相册详情")]),
          _c("span", [_vm._v(_vm._s(_vm.albumDetails.description))]),
        ]),
        _c(
          "div",
          {
            staticClass: "album_tips",
            class: _vm.deleteShow ? "delete_show" : "",
          },
          [
            _vm._m(0),
            _c("span", [
              _vm._v("已成功删除" + _vm._s(_vm.delNumber) + "个影像"),
            ]),
          ]
        ),
      ]),
      _c("div", {
        staticClass: "album_tips_zw",
        class: _vm.deleteShow ? "seat_show" : "",
      }),
      _vm.albumDetails.userPhotoList &&
      Object.keys(_vm.albumDetails.userPhotoList).length
        ? _c(
            "div",
            { staticClass: "album_list_box" },
            [
              _c(
                "van-list",
                {
                  attrs: {
                    finished: _vm.finished,
                    "finished-text": "没有更多了",
                    "immediate-check": false,
                    offset: 10,
                  },
                  on: { load: _vm.onLoad },
                  model: {
                    value: _vm.loading,
                    callback: function ($$v) {
                      _vm.loading = $$v
                    },
                    expression: "loading",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "album_item",
                      style: {
                        paddingBottom: _vm.isShowCheck ? "70px" : "10px",
                      },
                    },
                    _vm._l(
                      _vm.albumDetails.userPhotoList,
                      function (value, key, index) {
                        return _c(
                          "div",
                          { key: index },
                          _vm._l(value, function (photoElement, photoIndex) {
                            return _c("div", { key: photoIndex }, [
                              _c("div", { staticClass: "album_item_title" }, [
                                _c(
                                  "div",
                                  { staticClass: "album_item_title_date" },
                                  [_vm._v(_vm._s(key))]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "album_item_title_name" },
                                  [_vm._v(_vm._s(photoElement.showText))]
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "album_item_content" },
                                _vm._l(
                                  photoElement.photoList,
                                  function (imgItem, imgIndex) {
                                    return _c(
                                      "div",
                                      {
                                        key: imgIndex,
                                        staticClass: "item_img_box",
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.check(
                                              key,
                                              photoIndex,
                                              imgIndex,
                                              imgItem
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("van-image", {
                                          staticClass: "item_img",
                                          attrs: {
                                            width: "111px",
                                            height: "111px",
                                            fit: "cover",
                                            radius: "4",
                                            src: _vm._f("imgFormat")(
                                              imgItem.photo
                                            ),
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "error",
                                                fn: function () {
                                                  return [
                                                    _c("img", {
                                                      staticClass: "err_img",
                                                      attrs: {
                                                        src: require("../../assets/styles/themes/img/photoAlbum1-mobile.png"),
                                                        alt: "",
                                                      },
                                                    }),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _vm.isShowCheck
                                          ? _c("van-checkbox", {
                                              staticClass: "item_check",
                                              attrs: { value: imgItem.checked },
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  if (
                                                    $event.target !==
                                                    $event.currentTarget
                                                  ) {
                                                    return null
                                                  }
                                                  return _vm.check(
                                                    key,
                                                    photoIndex,
                                                    imgIndex,
                                                    imgItem
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                0
                              ),
                            ])
                          }),
                          0
                        )
                      }
                    ),
                    0
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _c("DsfMobileUploadImg", {
        ref: "upload",
        attrs: {
          uploadFileSize: 1073741824,
          requestUrl: ":/file/upload/",
          accept: _vm.isAndroid ? "image/*" : ".jpg,.jpeg,.png",
        },
        on: { "value-change": _vm.headSuccess },
      }),
      !_vm.isShowCheck
        ? _c(
            "div",
            { staticClass: "add_album_item", on: { click: _vm.downloadClick } },
            [_c("i", { staticClass: "iconfont icon-add" })]
          )
        : _vm._e(),
      _vm.isShowCheck
        ? _c("div", { staticClass: "btn_album_bottom" }, [
            _vm.chooseArr.length
              ? _c(
                  "div",
                  {
                    staticClass: "btn_list",
                    class: [
                      _vm.chooseArr.length > 1 || !_vm.showEdit
                        ? "ash_btn"
                        : "",
                    ],
                    on: { click: _vm.editValue },
                  },
                  [
                    _c("i", { staticClass: "iconfont icon-bianji" }),
                    _c("span", [_vm._v("编辑")]),
                  ]
                )
              : _vm._e(),
            _c(
              "div",
              {
                staticClass: "btn_list",
                class: [!_vm.chooseArr.length ? "ash_btn" : ""],
                on: { click: _vm.download },
              },
              [
                _c("i", { staticClass: "iconfont icon-yunduanxiazai" }),
                _c("span", [_vm._v("下载")]),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "btn_list",
                class: [
                  !_vm.chooseArr.length || !_vm.showDelete ? "ash_btn" : "",
                ],
                on: { click: _vm.deletePhoto },
              },
              [
                _c("i", { staticClass: "iconfont icon-delete" }),
                _c("span", [_vm._v("删除")]),
              ]
            ),
          ])
        : _vm._e(),
      _c("van-image-preview", {
        attrs: {
          images: _vm.preview,
          "class-name": "preview_box",
          "start-position": _vm.startPosition,
        },
        on: { change: _vm.onChange, close: _vm.onClose },
        model: {
          value: _vm.show,
          callback: function ($$v) {
            _vm.show = $$v
          },
          expression: "show",
        },
      }),
      _c(
        "van-dialog",
        {
          attrs: { title: "照片描述", "show-cancel-button": "" },
          on: { confirm: _vm.sureDescribe },
          model: {
            value: _vm.editDialog,
            callback: function ($$v) {
              _vm.editDialog = $$v
            },
            expression: "editDialog",
          },
        },
        [
          _c("van-field", {
            attrs: {
              rows: "4",
              type: "textarea",
              maxlength: "200",
              placeholder: "请输入照片描述",
              "show-word-limit": "",
              autosize: { maxHeight: 100, minHeight: 50 },
            },
            model: {
              value: _vm.describeValue,
              callback: function ($$v) {
                _vm.describeValue = $$v
              },
              expression: "describeValue",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("i", { staticClass: "iconfont icon-duigou" })])
  },
]
render._withStripped = true

export { render, staticRenderFns }